import '../../styles/CAS.css';

/*Iconos*/
import Casco_icon from '../../imagenes/icons/casco.gif';
import Bases_icon from '../../imagenes/icons/bases.gif';
import Resolucion_icon from '../../imagenes/icons/anexos.gif';
import Anexos_icon from '../../imagenes/icons/anexos.gif';
import Comunicado_icon from '../../imagenes/icons/comunicado.gif';
import FeErratas_icon from '../../imagenes/icons/feErratas.gif';
import EvaCV_icon from '../../imagenes/icons/evaluacion.gif';
import Cronograma_icon from '../../imagenes/icons/cronograma.gif';
import Entrevista_icon from '../../imagenes/icons/entrevista.gif';
import ResultFinal_icon from '../../imagenes/icons/resultados.gif';

/*Documentos*/
import Lineamientos_pdf from '../../documentos/nombramientos/Nombramiento_I_2025/LINEAMIENTOS_NOMBRAMIENTO_DE_PERSONAL_DL_276.pdf';
import Resolucion_pdf from '../../documentos/nombramientos/Nombramiento_I_2025/RESOLUCION_0427_2025_NOMBRAMIENTO_276.pdf';
import Anexos_excel from '../../documentos/nombramientos/Nombramiento_I_2025/Anexo-2-Curriculo-Vitae.xlsx';
import Comunicado_01_pdf from '../../documentos/CAS/CASV2025/COMUNICADO_CAS_V_01_2025.pdf';
import Comunicado_02_pdf from '../../documentos/CAS/CASIII2025/COMUNICADO_CAS_III_02_2025.pdf';
import Fe_Erratas_01_pdf from '../../documentos/CAS/CASV2025/FE_DE_ERRATAS_01_2025.pdf';
import Fe_Erratas_02_pdf from '../../documentos/CAS/CASIV2025/FE_DE_ERRATAS_02_2025.pdf';
import Result_CV_pdf from '../../documentos/CAS/CASV2025/RESULTADOS_DE_EVALUACION_CURRICULAR_05_2025.pdf';
import Cronograma_pdf from '../../documentos/nombramientos/Nombramiento_I_2025/CRONOGRAMA_NOMBRAMIENTO_I_2025.pdf';
import ResultFinal_pdf from '../../documentos/nombramientos/Nombramiento_I_2025/RESULTADO_FINAL_NOMBRAMIENTO_I_2025.pdf';

function NombramientoI2025(){
  const documentos=[
    {
      titulo: 'Lineamiento del nombramiento',
      icon: Bases_icon,
      nombre: 'Ver Documento',
      url: Lineamientos_pdf,
    },
    {
      titulo: 'Resolución de Gerencia Municipal',
      icon: Resolucion_icon,
      nombre: 'Ver Anexos',
      url: Resolucion_pdf,
    },
    {
      titulo: 'Cronograma del proceso',
      icon: Cronograma_icon,
      nombre: 'Ver Cronograma',
      url: Cronograma_pdf,
    },
    {
      titulo: 'Anexo 02: Curriculum Vitae',
      icon: Anexos_icon,
      nombre: 'Ver Anexo',
      url: Anexos_excel,
    },
    {
      titulo: 'Resultados Finales',
      icon: ResultFinal_icon,
      nombre: 'Ver Resultados',
      url: ResultFinal_pdf,
    },
  ];
  return(
    <section className='cas-section'>
      <div className='titulo-cas'>
        <img src={Casco_icon} className='titulo-icon'></img>
        <h2>Proceso de nombramiento Nº001-2025-MPCH</h2>
      </div>
      <p className='subtitulo'>Nombramiento de personal de la Municipalidad Provincial de Chumbivilcas</p>
      <div className='cas-grid'>
        {documentos.map((doc, index) => (
          <div className='cas-card' key={index}>
            <img src={doc.icon} className='doc-icon'></img>
            <h3>{doc.titulo}</h3>
            <a
            href={doc.url}
            target="_blank"
            rel="noopener noreferrer"
            >
            {doc.nombre}
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};
export default NombramientoI2025;